import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import * as styles from './index.css';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var PickerInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(PickerInfo, _React$Component);
  var _super = _createSuper(PickerInfo);
  function PickerInfo() {
    var _this;
    _classCallCheck(this, PickerInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderSectionInfo", function () {
      var selectedSection = _this.props.selectedSection;
      if (!selectedSection) {
        return null;
      }
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [_this.renderItem(selectedSection.house.name, 1), _this.renderItem("\u0421\u0435\u043A\u0446\u0438\u044F ".concat(selectedSection.sectionData.number), 2)]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderItem", function (text, key) {
      return /*#__PURE__*/_jsx("li", {
        className: styles['item'],
        children: text
      }, key);
    });
    return _this;
  }
  _createClass(PickerInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        selectedSection = _this$props.selectedSection,
        floor = _this$props.floor,
        isFlatView = _this$props.isFlatView;
      if (!selectedSection && !floor) {
        return null;
      }
      if (isFlatView) {
        return /*#__PURE__*/_jsx("div", {
          className: styles['container--simple'],
          children: "\u041F\u043E\u0445\u043E\u0436\u0438\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u044D\u0442\u0430\u0436\u0430\u0445"
        });
      }
      return /*#__PURE__*/_jsxs("ul", {
        className: styles['container'],
        children: [floor && this.renderItem("".concat(floor, " \u044D\u0442\u0430\u0436"), 0), this.renderSectionInfo()]
      });
    }
  }]);
  return PickerInfo;
}(React.Component);